export default {"src":"/_next/static/media/application-market.511c037e.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};